//
// Access to the api happens through getApi()
//

import { Api } from './api/Api';
import { Log2 } from '@pdcplan/shared/api/NotificationLog';
import { Logout } from '@pdcplan/shared/api/Login';
import { ReportTracking } from '@pdcplan/shared/api/Tracking';

let api: Api | null = null;

/**
 *
 * @example
 * const mock = mockApi({
 *  getThing: async () => ({ data: [] })
 * });
 *
 * beforeAll(() => {
 *  mock.begin();
 * });
 *
 * afterAll(() => {
 *  mock.restore();
 * });
 */
export function mockApi(mock: Partial<Omit<Api, 'fetch' | 'baseUrl'>>) {
  const original = getApi();
  return {
    begin: () => {
      const mocked = new Api();
      for (const key in mock) {
        (mocked as any)[key] = (mock as any)[key];
      }
      api = mocked;
    },
    restore: () => {
      api = original;
    },
  };
}

export default function getApi(): Api {
  if (api) {
    return api;
  }

  api = new Api();

  return api;
}

export function cancelRequestsOnLogout() {
  getApi().cancelActiveRequests((instance) => {
    if (!instance.noUserValidation) {
      // Some methods are user validated, but should not be cancelled
      // This is ok, as their responses do not affect the frontend state
      return ![ReportTracking, Logout, Log2].some(
        (Class) => instance instanceof Class
      );
    }
    return false;
  });
}
